import React, { useEffect, useState } from "react";

import { useDeviceTesterStateContext } from "../../device-tester-context-provider/DeviceTesterContextProvider";
import { usePlatformTypeContext } from "../../platform-type-provider/PlatformTypeProvider";

import { logDevicePermissionEvent } from "./ConnectedResultsView.telemetry";
import { ResultsView } from "./ResultsView";

// Results page for desktop and mobile devices
export const ConnectedResultsView: React.FC = () => {
  const { deviceTesterState } = useDeviceTesterStateContext();
  const [permissionDenied, setPermissionDenied] = useState(false);
  const { isMobile } = usePlatformTypeContext();

  useEffect(() => {
    if (
      (!deviceTesterState.deviceSettings.cameraAccess ||
        !deviceTesterState.deviceSettings.micAccess) &&
      deviceTesterState.isInfoFetched
    ) {
      //log user denied mic and camera permission
      logDevicePermissionEvent(false);

      setPermissionDenied(true);
    } else {
      //log user allowed mic and camera permission
      logDevicePermissionEvent(true);

      setPermissionDenied(false);
    }
  }, [
    deviceTesterState.deviceSettings.cameraAccess,
    deviceTesterState.deviceSettings.micAccess,
    deviceTesterState.isInfoFetched,
  ]);

  return (
    <ResultsView
      camAccess={deviceTesterState.deviceSettings.cameraAccess}
      micAccess={deviceTesterState.deviceSettings.micAccess}
      isInfoFetched={deviceTesterState.isInfoFetched}
      permissionDenied={permissionDenied}
      isMobile={isMobile}
    />
  );
};
